import React from 'react';
import PropTypes from 'prop-types';
import { changeCart } from '@utils/shopify-helpers';

const CartReaderInput = ({ readerStrength, item, bundleKey }) => {
	const readerStrengthOptions = ['0.25', '0.50', '0.75', '1.00', '1.25', '1.50', '1.75', '2.00', '2.25', '2.50', '2.75'];

	const handleCartReaderChange = async newValue => {
		const properties = { ...item.properties };
		properties._readerStrength = newValue;
		const data = {
			id: item.key,
			properties,
		};

		await changeCart(data);
	};

	return (
		<div className='item-prescription p-0 d-flex flex-column flex-lg-row'>
			<div className='full-width'>
				<div id='readers-option' data-bundle={bundleKey} data-line={item.key}>
					<div className='justify-content-center'>
						<select
							onChange={({ target: { value } }) => handleCartReaderChange(value)}
							className='option-select pair-btn--sm pair-btn__secondary with-border dropdown button'
							placeholder={`+${readerStrength}`}
						>
							$
							{readerStrengthOptions.map(strength => {
								return strength === readerStrength ? (
									<option selected value={strength}>
										+{strength}
									</option>
								) : (
									<option value={strength}>+{strength}</option>
								);
							})}
						</select>
					</div>
				</div>
			</div>
		</div>
	);
};

CartReaderInput.propTypes = {
	readerStrength: PropTypes.string,
	item: PropTypes.shape({}),
	bundleKey: PropTypes.string,
};

export default CartReaderInput;
